// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"j28ISlU2Is+w","root":"ZOgKKYed1vnM"};